import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import IconSuccess from '~icons/heroicons/check-circle-solid'

interface SuccessNotificationProps {
  message: string
  onClose: () => void
  duration?: number
}

export const SuccessNotification = ({ message, onClose, duration = 3000 }: SuccessNotificationProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, duration)

    return () => clearTimeout(timer)
  }, [onClose, duration])

  const notificationContent = (
    <div
      className='fixed top-8 left-1/2 z-[999999] pointer-events-none'
      style={{
        filter: 'none',
        backdropFilter: 'none',
        isolation: 'isolate',
        transform: 'translateX(-50%)',
      }}
    >
      <div className='flex w-[497px] max-w-[90vw] p-[10px] items-center gap-3 rounded-[5px] border-[0.6px] border-success-500 dark:border-success-400 bg-white dark:bg-neutral-1000 shadow-[0_2px_20px_0_rgba(0,0,0,0.15)] dark:shadow-[0_2px_20px_0_rgba(255,255,255,0.10)] pointer-events-auto animate-slide-down transition-colors'>
        <IconSuccess className='w-6 h-6 text-success-500 dark:text-success-400 flex-shrink-0 transition-colors' />
        <div className='flex-1'>
          <p className='text-neutral-900 dark:text-neutral-50 text-[14px] font-normal leading-[18px] transition-colors'>{message}</p>
        </div>
      </div>
    </div>
  )

  return createPortal(notificationContent, document.body)
}

